import Component from '../inherited/Component'
import { create } from 'evx'
import Helpers from '../lib/Helpers'
import KeenSlider from 'keen-slider'

export default class KeenSliderComp extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._options = {...{
      slidesPerView: 1,
      dragSpeed: 1,
      autoplaySpeed: 5000,
      duration: 500,
      autoAdjustSlidesPerView: false,
      arrowSvg: `
      <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M.55 13.208c-.473.434-.483.868-.03 1.302.454.434.898.434 1.332 0l6.156-6.155c.197-.158.295-.375.295-.651s-.098-.493-.295-.651L1.852.898C1.418.464.974.464.521.898c-.454.434-.444.868.03 1.302l5.444 5.504L.55 13.208z" fill="#000"/>
      </svg>
      `
    }, ...this._options}
    this._slider = null
    this._autoplayInterval = null
    this.shouldAutoplay = false
    this._localCtx = create()
    this._isMounted = false

    super.reinitOnResize()
  }

  mount () {
    if (this._options.mount === false) {
      return false
    }

    if (this._options.enableWhen && !matchMedia(`only screen and ${this._options.enableWhen}`).matches) {
      window.addEventListener('resize', e => {
        if (matchMedia(`only screen and ${this._options.enableWhen}`).matches && !this._isMounted) {
          this.mount()
        } else if(!matchMedia(`only screen and ${this._options.enableWhen}`).matches && this._isMounted) {
          this.unmount()
          this._isMounted = false
        }
      }, { passive: true })
      return false
    }
    
    this._elem.classList.add('keen-slider')
    for (let elem of this._elem.children) {
      if (elem.hasAttribute('data-keen-dots') || elem.hasAttribute('data-keen-nav')) continue
      elem.classList.add('keen-slider__slide')
      if (this._options.fade) {
        elem.classList.add('fader-slide')
      }
    }
    this._slides = this._elem.querySelectorAll('.keen-slider__slide')

    // AS NAV FOR
    if (this._options.asNavFor) {
      this._ctx.on('ffc--mounted', e => {
         this._parentSlider = this._theme.getComponent(this._options.asNavFor)
         this._parentSlider = this._parentSlider.component

        this._parentSlider._localCtx.on('slide-change', (state, data) => {
           this.goToSlide(data.slide)
         })
      })
    }

    if (this._options.arrows) this._createArrows()
    if (this._options.dots && this._slides.length > 1) this._createDots()
    

    if (this._slides.length === this._options.slidesPerView) {
      this._options.loop = false
      this._options.controls = false
    }

    this._dotsContainer = this._options.dotsContainer ? document.querySelector(this._options.dotsContainer) || this._elem : this._elem
    this._dots = this._dotsContainer.querySelectorAll('[data-dot]')

    if (!this._prevArrow) this._prevArrow = this._elem.querySelector('[data-keen-prev]')
    if (!this._nextArrow) this._nextArrow = this._elem.querySelector('[data-keen-next]')

    this._options.slideChanged = (slider) => {
      this.updateClasses(slider)
      this.updateFadeHeight(slider)
      this._localCtx.emit('slide-change', null, { slide: slider.details().relativeSlide })
      this.adaptiveHeight(slider)
      if (this._isMounted) this.scrollRevealFix(slider)

      this._pauseVideos()
      if (this._options.playVideos) this._playVideos(slider)
      if (this._options.setSlideCount) this._setSlideCount(slider)

      this._doSlideCSSVars(slider)

      this.autoplay()

      if (this._options.asNavFor && this._parentSlider) {
        let slide = slider.details().relativeSlide
        this._parentSlider.goToSlide(slide)
      }
    }

    this._options.created = (slider) => {
      this._elem.classList.add('keen-slider--ready')
      this.updateClasses(slider)
      this.updateFadeHeight(slider)
      this.adaptiveHeight(slider)
      this._doSlideCSSVars(slider)

      if (this._options.autoplay) this._setupAutoplay()
      if (this._options.alignArrowsTo) this.alignArrows()
      if (this._options.arrowKeyNavigation) this._addArrowKeyEvents()
      if (this._options.playVideos) this._playVideos(slider)
      if (this._options.setSlideCount) this._setSlideCount(slider)
      if (this._options.focusOnSelect) this.focusOnSelect(slider)

      window.addEventListener('resize', e => {
        this.updateFadeHeight()
        this.adaptiveHeight()

        if (this._options.alignArrowsTo) {
          Helpers.nextFrame(() => {
            this.alignArrows()
          })
        }
      }, { passive: true })

    }

    this._options.dragStart = () => {
      this.shouldAutoplay = false
    }

    this._options.dragEnd = () => {
      this.shouldAutoplay = true
    }
    
    if (this._options.fade) {
      this._options.move = (slider) => this.fader(slider)
    }

    this._slider = new KeenSlider(this._elem, this._options)

    if (this._prevArrow) this._prevArrow.addEventListener('click', e => this.goToPrev(e))
    if (this._nextArrow) this._nextArrow.addEventListener('click', e => this.goToNext(e))

    for (let dot of this._dots) {
      dot.addEventListener('click', e => {
        e.preventDefault()
        let dontAnimate = !!dot.dataset.dotAnimate

        this.goToSlide(dot.dataset.dot, dontAnimate)

        if (this._parentSlider) {
          this._parentSlider.goToSlide(dot.dataset.dot)
        }
      })
    }

    this._isMounted = true

    if (this._options.triggerOnMount) {
      this._ctx.emit(this._options.triggerOnMount)
    }
  }

  focusOnSelect (slider = this._slider) {
    for (let [index, slide] of this._slides.entries()) {
      slide.addEventListener('click', e => {
        this.goToSlide(index)
      })
    }
  }

  _setSlideCount(slider = this._slider) {
    let slideCountParentElem = document.querySelector(this._options.setSlideCount)
    let totalElem = slideCountParentElem.querySelector('[data-slide-total]')
    let currentElem = slideCountParentElem.querySelector('[data-slide-current]')

    totalElem.innerHTML = slider.details().size
    currentElem.innerHTML = slider.details().relativeSlide + 1

    if (this.isAtEnd(slider) && slider.details().relativeSlide == 0) {
      slideCountParentElem.classList.add('hide')
    }
  }


  unmount () {
    this._slider.destroy()
    if (this._navContainer) {
      this._navContainer.parentNode.removeChild(this._navContainer)
    }
    this._elem.classList.remove('keen-slider')
    for (let elem of this._elem.children) {
      elem.classList.remove('keen-slider__slide')
      elem.classList.remove('fader-slide')
      elem.removeAttribute('style')
    }
  }

  _setupAutoplay () {
    this.shouldAutoplay = true
    this.autoplay()

    if (this._options.pauseAutoplayOnHover) {
      this._elem.addEventListener('mouseover', e => {
        this.shouldAutoplay = false
      })

      this._elem.addEventListener('mouseout', e => {
        this.shouldAutoplay = true
      })
    }
  }

  _doSlideCSSVars (slider = this._slider) {
    let slide = this.getActiveSlideElem(slider)

    if (slide && slide.dataset.slideCssVars) {
      let varArr = JSON.parse(slide.dataset.slideCssVars);

      for (let cssVar of varArr) {
        let toSetOn = document.querySelector(cssVar.onElem)

        if (toSetOn) {
          toSetOn.style.setProperty(cssVar.var,cssVar.value)
        }
      }
    }
  }

  _addArrowKeyEvents () {
    document.addEventListener('keydown', e => {
      let ev = e || window.event;
      if (ev.keyCode === 37) {
         // left arrow
         this._slider.prev()
      } else if (ev.keyCode === 39) {
         // right arrow
         this._slider.next()
      }
    })
  }

  _createArrows () {
    var e = document.createElement('ul');
    e.classList.add('keen-nav')
    e.setAttribute('data-keen-nav', true)
    e.innerHTML = `
        <li>
          <button data-keen-prev class="keen-arrow-prev keen-arrow" aria-label="Previous Slide">
            ${this._options.arrowSvg || ''}
          </button>
        </li>
        <li>
          <button data-keen-next class="keen-arrow-next keen-arrow" aria-label="Next Slide">
            ${this._options.arrowSvg || ''}
          </button>
        </li>
    `;
    this._navContainer = e
    this._prevArrow = this._navContainer.querySelector('[data-keen-prev]')
    this._nextArrow = this._navContainer.querySelector('[data-keen-next]')

    if (this._options.appendArrows) {
      let toAppend = document.querySelector(this._options.appendArrows)
      if (toAppend) toAppend.appendChild(e) 
    } else {
      this._elem.appendChild(e) 
    }
  }

  _createDots () {
    var e = document.createElement('ul');
    e.classList.add('keen-dots')
    e.setAttribute('data-keen-dots', true)

    let dotsToMake = Math.ceil(this._slides.length / this._options.slidesPerView)

    for (let i = 0; i < dotsToMake; i++) {
      e.innerHTML += `
        <li>
          <button data-dot='${i * this._options.slidesPerView}'></button>
        </li>
      `
    }

    this._elem.classList.add('keen--dotted')
    this._elem.appendChild(e) 
  }

  _playVideos (slider = this._slider) {
    this._pauseVideos()

    Helpers.nextFrame(() => {
      let active = this.getActiveSlideElem()
      let activeVideo = active.querySelector('video')

      if (activeVideo) {
        if (activeVideo.hasAttribute('[data-lazy]') && !activeVideo.classList.contains('loaded')) {
          activeVideo.addEventListener('ffc--loaded', e => {
            console.log('loaded Event')
            activeVideo.play()
          })
        } else {
          activeVideo.play()
        }
      }
    })
  }

  _pauseVideos () {
    let videos = this._elem.querySelectorAll('video')
    for (let video of videos) {
      video.pause()
    }
  }

  fader (slider = this._slider) {
    var opacities = slider.details().positions.map((slide) => slide.portion)
    for (let [index, slide] of this._slides.entries()) {
      slide.style.opacity = opacities[index]
    }
  }

  goToSlide (index, dontAnimate = false) {
    let duration = dontAnimate ? 0 : 500

    let nearest = false

    if (this._options.loop && this._slider.details().size > 2) {
      nearest = true
    }
    this._slider.moveToSlideRelative(index, nearest, duration)
  }

  goToPrev (e) {
    e.preventDefault()
    this._slider.prev()
  }

  goToNext (e) {
    e.preventDefault()
    this._slider.next()
  }

  scrollRevealFix () {
    for (let slide of this._slides) {
      if (slide.hasAttribute('data-reveal')) {
        slide.style.removeProperty('opacity')
        slide.style.removeProperty('transition')
        slide.style.removeProperty('visibility')
        slide.removeAttribute('data-reveal')
      }
    }
  }

  getActiveSlideElem (slider = this._slider) {
    let slideIndex = slider.details().relativeSlide

    for (let [index, slide] of this._slides.entries()) {
      if (index === slideIndex) {
        return slide
      }
    }

    return false
  }

  adaptiveHeight (slider = this._slider) {
    if (!this._options.adaptiveHeight || !slider) return false

    this._elem.classList.add('keen--adaptive-height')
  
    let slide = slider.details().relativeSlide
    
    let height = 0

    height += parseFloat(getComputedStyle(this._elem).paddingBottom)
    height += parseFloat(getComputedStyle(this._elem).paddingTop)

    let activeSlide = this.getActiveSlideElem(slider)

    if (!activeSlide) return

    height += activeSlide.clientHeight
    this._elem.style.height = `${height}px`
  }

  updateFadeHeight (slider = this._slider) {
    if (!this._options.fade || !slider) return false

    let slide = slider.details().relativeSlide
    
    let height = 0

    height += parseFloat(getComputedStyle(this._elem).paddingBottom)
    height += parseFloat(getComputedStyle(this._elem).paddingTop)

    let activeSlide = this.getActiveSlideElem(slider)
    if (!activeSlide) return

    height += activeSlide.getBoundingClientRect().height

    this._elem.style.height = `${height}px`

    if (!this._elem.classList.contains('fade-slider')) {
      this._elem.classList.add('fade-slider')
    }
  }

  alignArrows () {
    if (!this._options.alignArrowsTo) return false
    let elem = this._elem.querySelector(this._options.alignArrowsTo)
    this._navContainer.style.top = `${elem.clientHeight / 2}px`
  }

  updateClasses (slider) {
    if (!slider) return false

    let slide = slider.details().relativeSlide
    let maxSlides = slider.details().size
    let endSlide = slide + slider.details().slidesPerView

    let canSlide = slider.details().slidesPerView !== maxSlides

    if (this._prevArrow && !this._options.loop) {
      if (slide === 0 || !canSlide) {
        this._prevArrow.setAttribute('disabled', 'disabled')
      } else {
        this._prevArrow.removeAttribute('disabled')
      }
    }

    if (this._nextArrow && !this._options.loop) {
      if (this.isAtEnd(slider) || !canSlide) {
        this._nextArrow.setAttribute('disabled', 'disabled')
      } else {
        this._nextArrow.removeAttribute('disabled')
      }
    }

    if (this._dots) {
      let dotIndex = Math.floor(slide / slider.details().slidesPerView) * slider.details().slidesPerView

      for (let dot of this._dots) {
        dot.classList.remove('active')

        if (Number(dot.dataset.dot) === dotIndex) {
          dot.classList.add('active')
        }
      }
    }

    let activeSlide = this.getActiveSlideElem(slider)

    for (let slide of this._slides) {
      slide.classList.remove('active')
    }

    if (activeSlide) {
      activeSlide.classList.add('active')
    }
  }

  isAtEnd (slider = this._slider) {
    let slide = slider.details().relativeSlide
    let maxSlides = slider.details().size
    let endSlide = slide + Math.floor(slider.details().slidesPerView)
    return endSlide === maxSlides
  }

  autoplay () {
    if (!this._options.autoplay) {
      if (this._autoplayInterval) clearInterval(this._autoplayInterval)
      return false
    }
    clearInterval(this._autoplayInterval)
    this._autoplayInterval = null

    this._autoplayInterval = setInterval(() => {

      if (this.shouldAutoplay && this._slider) {

        if (this.isAtEnd() && !this._options.loop) {
          this.goToSlide(0)
        } else {
          this._slider.next()
        }
      }
    }, this._options.autoplaySpeed)
  }

  refresh () {
    return this._slider.refresh()
  }

  resize () {
    return this._slider.resize()
  }
}